import { Button, Modal } from '@hakimo-ui/shared/ui-base';
import { ReactNode } from 'react';

interface Props {
  open: boolean;
  title: string;
  message: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function ToggleConfirmationModal(props: Props) {
  const {
    open,
    title,
    message,
    onConfirm,
    onCancel,
    isLoading = false,
  } = props;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      closable={!isLoading}
      disableBackdropClose={isLoading}
      footer={
        <>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            Yes
          </Button>
          <Button variant="outline" onClick={onCancel} disabled={isLoading}>
            No
          </Button>
        </>
      }
    >
      <div className="px-8 py-6">
        <p className="text-onlight-text-1 dark:text-ondark-text-1 text-sm">
          {message}
        </p>
      </div>
    </Modal>
  );
}

export default ToggleConfirmationModal;
